<template>
  <div>
    <SvgPanZoom
      v-if="!backMode"
      :panEnabled="false"
      :zoomEnabled="false"
      :controlIconsEnabled="false"
      :dblClickZoomEnabled="false"
      :preventMouseEventsDefault="false"
      :fit="true"
      :contain="true"
      :center="true"
      @svgpanzoom="registerSvgPanZoom"
      :customEventsHandler="customEventsHandler"
    >
      <svg
        :style="{
          width: svgWidth,
          height: svgHeight,
        }"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Page-1">
          <g class="face">
            <path
              id="路径"
              class="st0"
              d="M169.35001,598.06c0.53,0.58002,1.06,1.16998,1.59999,1.73999
c16.31,17.65997,32,36.20001,50.68001,51.22998C241.77,667.20001,262.81,671.5,288.07999,671.87H292.44h4.35999
c25.27002-0.37,46.31-4.66998,66.45001-20.84003c18.73001-15,34.37-33.57001,50.69-51.22998
c2.26666-2.45331,4.5-4.95667,6.70001-7.51001c18.09998-21.06,33.28-45.40997,40-72.87
c16.75-68.07001,25.10999-138.91,26.41998-209.14999c0.75-40.13-1.10999-81.17-14.89999-118.61
c-10-27.22-27.11002-52.56-50.39999-68.94c-21.89001-15.39-54.10001-18.58-79.86002-21.55c-16.41-1.89001-33-2.93-49.48999-2
c-16.45999-1-33.08002,0.07-49.49001,2c-25.75999,3-58,6.16-79.86,21.55c-23.28999,16.38-40.38,41.72-50.39999,68.94
C98.9,229.11998,97,270.15997,97.79,310.28998C99.1,380.53,107.47,451.37,124.21,519.44
C131.59,549.44,149,575.73999,169.35001,598.06z"
            />
            <path
              id="路径_00000044170535952273667640000005607629347930390936_"
              class="st0"
              d="M286.45999,829.06
c1.62424-0.1377,3.23355-0.41541,4.81-0.83002c3.95471-1.16156,7.73773-2.8429,11.25-5
c7-4.21002,13.27002-9.41998,19.93002-13.57001c3.20416-2.09863,6.62363-3.84857,10.19998-5.21997
c3.59155-1.29584,7.30826-2.21411,11.09-2.73999c7.63-1.11005,15.55002-1.23004,23.63-1.43005
c32.20001-0.81,64.37-2.12,96.53-3.71997s115.70999,3,129.51999-9.83002C555.25,775.19,518.51001,763.82001,479.5,749.01001
c-21.64001-8.21002-44.09-34.73004-52.54001-56.17004c-3.67999-9.34998-4.31-19.57001-4.88998-29.58997
c-0.32001-5.56-0.61002-11.16003-0.89999-16.79004c-1.07001-20-0.34003-37.75-0.53-54.08997
c-2.20001,2.54663-4.43335,5.04999-6.70001,7.51001C397.62,617.47998,382,636.06,363.25,651.06
c-20.14001,16.16998-41.17999,20.46997-66.45001,20.83997H292.44h-4.36002C262.81,671.52997,241.77,667.22998,221.63,651.06
c-18.73001-15-34.37001-33.57001-50.68001-51.22998c-0.53999-0.57001-1.06999-1.16003-1.59999-1.74005l0,0
c0.06999,14.63-0.08,33.57001,0,48.76001l0,0c-0.26001,5.27002-0.13,11.13-0.43001,16.34003c-0.58,10-1.2,20.23999-4.89,29.58997
c-8.44,21.44-30.89999,48-52.53,56.17004C73.18,763.47998,37.39,775.79999,0,787.19c13.81,12.83997,76.85,7.67999,109,9.29999
s64.33,2.90997,96.53,3.71997c8.08,0.20001,16,0.32001,23.64,1.43005c3.77847,0.526,7.49185,1.44427,11.08,2.73999
c3.57867,1.37329,7.00124,3.12311,10.21001,5.21997c6.64998,4.15002,12.89,9.35999,19.93001,13.57001
c3.51038,2.16064,7.29388,3.84222,11.25,5c1.57626,0.41547,3.18564,0.69318,4.81,0.83002"
            />
            <path
              id="路径_00000135666348525742537340000010724424101772799407_"
              class="st1"
              d="M295,722.10999l-1.07001,0.07001
c-15.51358-0.68201-30.75818-4.29211-44.92999-10.64001c-24.23-11.12-51.5-31.69-63.56-44.69
c-3.38-3.64001-13.41-15.79999-16.09-20c0-15.19,0.11-34.13,0-48.76001l0,0c0.53,0.58002,1.06,1.17004,1.59999,1.74005
c16.31,17.65997,32,36.19995,50.68001,51.22998c20.14,16.16998,41.17999,20.46997,66.44998,20.83997H292.44h4.35999
c25.27002-0.37,46.31-4.66998,66.45001-20.83997c18.73001-15,34.37-33.57001,50.69-51.22998
c2.26666-2.45337,4.5-4.95673,6.70001-7.51001c0.18997,16.33997-0.54001,34.08997,0.53,54.08997
c-2.67001,4.21002-13.24002,16.81-16.62003,20.45001c-12.06,13-39.32999,33.57001-63.56,44.69
c-14.1756,6.34705-29.42331,9.95709-44.94,10.64001l-1.06998-0.07001"
            />
            <path
              id="路径_00000150820832592282648330000012559677050307095727_"
              class="st2"
              d="M286.45999,829.06
c4,0.33002,11.34-6.22003,14.51001-8.73999c6.32999-5.08002,12.09-11.08002,18.67001-16.44
c3.32629-2.7356,6.95291-5.08405,10.81-7c3.86395-1.82898,7.9187-3.22418,12.09-4.16003
c8.22998-1.89996,98.28-10.35999,189.92996,3.10004l0,0c-25.75998,0.52997-53.09998-0.14001-68.56998,0.63995
c-32.16,1.60004-64.32999,2.91003-96.53,3.72003c-8.07999,0.20001-16,0.32001-23.63,1.42999
c-3.78174,0.52594-7.49844,1.44421-11.09,2.73999c-3.57635,1.3714-6.99582,3.12134-10.19998,5.22003
c-6.66,4.14996-12.90002,9.35999-19.93002,13.57001c-3.51227,2.15704-7.29529,3.83838-11.25,5
c-1.57645,0.41461-3.18576,0.69232-4.81,0.82996"
            />
            <path
              id="路径_00000152236684080971642820000015358431155147006108_"
              class="st2"
              d="M286.45999,829.06
c-4,0.33002-11.35001-6.22003-14.51999-8.73999c-6.33002-5.08002-12.08002-11.08002-18.66-16.44
c-3.3282-2.73798-6.95842-5.08655-10.81999-7c-3.85992-1.83044-7.91151-3.22571-12.08-4.16003
c-8.23001-1.89996-98.29001-10.35999-189.94,3.10004l0,0c23.22,1,50.67-0.22003,68.57001,0.67999
c32.16,1.59998,64.32999,2.90997,96.52999,3.71997c8.08,0.20001,16,0.32001,23.64,1.42999
c3.77849,0.52606,7.49187,1.44434,11.08,2.74005c3.57869,1.37329,7.00125,3.12311,10.21001,5.21997
c6.64999,4.15002,12.88998,9.35999,19.92999,13.57001c3.51038,2.16064,7.29391,3.84222,11.25,5
c1.57626,0.41547,3.18567,0.69318,4.81,0.83002"
            />
            <path
              id="路径_00000173842052039954672120000016912032683603461296_"
              class="st0"
              d="M83.57,422.84998
c2.39765,5.70212,5.33784,11.16055,8.78,16.30002c6.18,9,23.41,35.91998,36.18999,22.13c2.72-3,2.52-7.48001,2.14-11.47
c-2.2-22.94-4.78999-45.83667-7.76999-68.69c-2.94-22.5-6.32001-45.19-14.63-66.30002c-2.74-6.94-6.12-13.85999-11.64-18.88998
c-10.7-9.77002-22.74-6.84-28,6.57001c-7.37,18.59-3,47.47998,0.43,66.48999C72.08,385.94998,76.26,405.88998,83.57,422.84998z"
            />
            <path
              id="路径_00000002344921074371016850000010732148167792541062_"
              class="st3"
              d="M353.16,297.15997
c-21.63,2.10001-35.29001,8.07001-37.88,34.71002c-0.29999,3-0.06,6.73999,2.64999,8.06998
c1.59027,0.61392,3.35876,0.5744,4.92001-0.10999c5.88-2,10.22998-6.92999,15.37-10.44
c8.57999-5.85999,19.31-7.79999,28.10999-13.32001c3.06003-1.91,5.95001-4.37,7.37003-7.69c1.41998-3.31998,1-7.62-1.75-9.94998
c-2.75-2.33002-6.40002-2.13-9.81-1.92999C359,296.67999,356,296.88998,353.16,297.15997z"
            />
            <path
              id="路径_00000039812568456076239470000005932089078944579228_"
              class="st3"
              d="M105.83,371.22998
c-1.37-5.88-14.94-50.34-24.76-44.12c-0.96589,0.7645-1.66581,1.81436-2,3c-1.7516,4.60846-2.96629,9.40341-3.62,14.29001
c-2-7.44-4.71999-53,13-34.88c7.62,7.78,11.46001,18.54999,13.42001,29.26999S104.11,360.47,105.83,371.22998z"
            />
            <path
              id="路径_00000139980439772224727950000017451937503690779327_"
              class="st3"
              d="M99.36,385.26999
c0.72,0.16998,1.07,1.35001,1.1,2.37c-0.05183,1.93314-0.46564,3.83939-1.22,5.62c-2.66,7.49002,0.91,9.41,3.06001,15.39001
c2.38,6.63998,1,14.5-0.27,21.29999c-0.56,2.87-1.55,6.30002-3.66,6.61002s-5.61-2.46002-6.64-4.89001
c-4.06001-9.57001-4.77-19.38998-7-30.09c-0.48-2.26001-0.74001-5.26001,0.7-6.47C88,401.59,90.52,414.39999,95,418.56
c0.57,0.53,1.42,0.89999,1.88,0.17999c0.18591-0.36331,0.29163-0.7623,0.31001-1.17001l0.87-6.66l0,0
c0.35001-2.78998-2.1-8.35999-2.27-11.78998c-0.21-4.33002,0.09-8.75,1.94-12.38C98.11,385.93997,98.68,385.10999,99.36,385.26999
z"
            />
            <path
              id="路径_00000057827034389108568110000010039697252698801812_"
              class="st3"
              d="M92.09,400.28998
c-0.36926-0.10541-0.69514-0.32617-0.92999-0.63c-2.58-2.68997-5.53001-5.62-7.18-9.89999c-1.65-4.28-3.86-10.85001-4.18-15.94998
c-0.58-9.24002-3-16.94-2.33-26.05002c0.25-3.69998,3.53-7.34,4.67-10.69998c0.22-0.68002,3.58-6.77002,3.67-6.13
c0.59929,4.34964,0.75342,8.74908,0.46,13.13c0.92001,0.28998,1.59-1.5,2.52-1.70001c1.22-0.26001,1.9,2.22,1.86,4.14999
c-0.19,10.85001-6.29,18.83002-4,30.57001c1.49,7.66,6.58,13.51999,6.3,21.51999c0.04027,0.54797-0.10407,1.09363-0.41,1.55002
C92.4186,400.26181,92.25341,400.3132,92.09,400.28998L92.09,400.28998z"
            />
            <path
              id="路径_00000034091272428205963560000016645037949173514146_"
              class="st0"
              d="M504.16,417.14999
c-2.40103,5.69922-5.34457,11.15433-8.79001,16.28998c-6.17999,9-23.39999,35.93002-36.17999,22.13
c-2.72-2.94-2.51999-7.47-2.14001-11.45999c2.20001-22.94,4.79001-45.83667,7.77002-68.69c2.94-22.5,6.32001-45.19,14.63-66.29999
c2.72998-6.95001,6.12-13.86002,11.62997-18.89999c10.71002-9.77002,22.75003-6.83002,28.06003,6.57999
c7.37,18.59,3,47.48001-0.42999,66.48999C515.64001,380.25,511.45999,400.18997,504.16,417.14999z"
            />
            <path
              id="路径_00000070084937749935710170000013249917200254917816_"
              class="st3"
              d="M481.89999,365.53
c1.37-5.88,14.94-50.34003,24.76001-44.12003c0.97,0.76071,1.6709,1.81204,2,3c1.76068,4.60626,2.97888,9.40192,3.62997,14.29001
c2-7.44,4.72003-52.94998-12.99997-34.88c-7.63,7.78-11.46002,18.55002-13.42001,29.27002S483.62,354.76999,481.89999,365.53z"
            />
            <path
              id="路径_00000080185258265046328440000012746546485867607685_"
              class="st3"
              d="M488.39001,383.82999
c-0.66,0.16-1,1.29001-1,2.26999c0.04346,1.84326,0.423,3.66309,1.12,5.37003c2.47,7.15997-0.84,9-2.83002,14.70999
c-2.19998,6.35001-1,13.85999,0.26001,20.35999c0.51001,2.74002,1.42999,6,3.38,6.32001
c1.94998,0.32001,3.22-2.35001,4.17999-4.67001c3.7373-9.29941,6.5834-18.93262,8.5-28.76999c0.44-2.16,0.67999-5-0.64999-6.19
c-2.39001,6.20001-4.75,18.45001-8.86002,22.42001c-0.53,0.50998,0.54001-2.54001,0.11002-3.22
c-0.19-0.30002-2.10001,2.67999-2.14999,2.28l-0.81-6.37l0,0c-0.33002-2.67001,1.93997-8,2.09998-11.28
c0.19-4.13-0.09-8.36002-1.78998-11.83002C489.56,384.47998,489,383.67999,488.39001,383.82999z"
            />
            <path
              id="路径_00000018920525948089390090000000841745311182407097_"
              class="st3"
              d="M496.35999,392.06
c0.38803-0.08426,0.73865-0.29114,1-0.59c2.65002-2.57001,5.69-5.38,7.39001-9.47c1.70001-4.09003,4-10.37003,4.29001-15.24002
c0.56998-8.39999-0.29001-16.66-0.89001-24.91c-0.25998-3.48999-0.38-7-1.50998-10.23999c-0.22-0.64999-3.69-6.47-3.78003-5.85999
c-0.61682,4.15002-0.77441,8.35541-0.46997,12.53998c-0.94,0.28-1.64001-1.44-2.59003-1.63c-1.25998-0.25-2,2.13-1.91998,4
c0.19998,10.38,6.47,18,4.12,29.22c-1.53,7.32001-6.76999,12.93002-6.48999,20.57001
c-0.03983,0.52905,0.11288,1.05466,0.42999,1.48001C496.05457,392.03207,496.20779,392.0795,496.35999,392.06L496.35999,392.06z"
            />
            <path
              id="路径_00000140712700344263309370000014601646732330801073_"
              class="st3"
              d="M243.69,298.06L243.69,298.06
c9.83,2.91998,17.22,9.84998,24.35999,21C284,344.06,283,374.20999,281.54001,402.25998
c-1.19,22.37-4.92001,44.17999,1.19,66.26001c0.91,3.26999,2,6.60999,4.44998,9.10999
c2.40863,2.35254,5.56409,3.78876,8.92001,4.06c3,0.29001,5.91998-1.43997,8.87-0.81c2.22,0.47,2.92999,3.26001,2.37,5.36002
c-3.44998,12.84-21.69998,9.07001-28.23001,1.34c-2.87-3.41-9.28998-24-17.10999-13.53c-3.16,4.23999,1,11.20999-2.85999,14.94
c-2.40002,2.34-6.85002,1.67999-9.25002-0.66s-3.17999-5.79999-3.31-9.07001c-0.53-12.48999,6.16-23.76999,9.55-35.50998
c3.19998-11.09003,4.19-23.71002,5-35.17001c0.85999-11.64001,2.23999-23.26001,2.32001-34.92999
c0.10999-15-4-28.20001-16.74001-36.88c-14.13-9.63-28.77-17.10001-40.31001-29.87c-1.81999-2-3.48-5.27002-1.36-7
C210.89,295.12997,236.91,296.06,243.69,298.06z"
            />
            <path
              id="路径_00000062906458281972655540000011278228523851929761_"
              class="st1"
              d="M272.73001,483.66998
c6.29999,1.39999,11.92999,4.76001,18.69998,4.87c8.89999,0.14999,26-11.17999,33.17999-3.19
c0.57455,0.53775,0.90955,1.28336,0.93002,2.07001c-0.24329,1.00461-0.92664,1.84592-1.86002,2.29001
c-4.56,2.87-10.22998,3.13998-15.37,4.69c-5.88998,1.75998-10.04999,5.78-16.56,6.17999c-9.56,0.59-17.57001-6.09-26.66-8.79001
c-1.70334-0.39746-3.36188-0.96707-4.94998-1.69998c-1.51001-0.82001-2.78003-2.21002-2.77008-3.80002
c0-4.47998,9.52008-3.41998,12.52008-3.10001C270.8446,483.2988,271.79266,483.45901,272.73001,483.66998L272.73001,483.66998z"
            />
            <path
              id="路径_00000135681619022876729180000011709358856599061400_"
              class="st4"
              d="M309.45999,483.69998
c4.22-1.85999,9-2.92999,13.33002-2.31c2.38998,0.33002,6.32999,1.45999,6,4.22c-0.30728,1.33105-1.27258,2.41324-2.56,2.87
c-1.0574,0.54037-2.17523,0.95325-3.33002,1.23001c-0.70029,0.14362-1.40976-0.20087-1.72998-0.84
c-0.17001-0.58002,0.25-1.14999,0.63998-1.63l0.89001-1.08002c0.16208-0.15079,0.25894-0.35886,0.26999-0.57999
c0-0.35001-0.45999-0.56-0.84-0.66c-2.51776-0.61057-5.1618-0.43964-7.58002,0.48999c-2.42999,0.81003-5,1.38-7.39999,2.33002
c-0.88998,0.35001-4.31,2.66998-5.06,1.25c-0.28-0.53,0.25-1.10001,0.75-1.47
C304.89288,485.99701,307.11417,484.71527,309.45999,483.69998z"
            />
            <path
              id="路径_00000120520467789765676170000017559415388446775227_"
              class="st4"
              d="M276.67999,483.69998
c-4.20999-1.85999-9-2.92999-13.32001-2.31c-2.38998,0.33002-6.34,1.45999-6.06,4.22c0.3092,1.33337,1.27872,2.41605,2.57001,2.87
c1.05466,0.5387,2.16898,0.95154,3.32001,1.23001c0.70029,0.14362,1.40976-0.20087,1.73001-0.84
c0.17999-0.58002-0.24002-1.14999-0.64001-1.63l-0.88-1.08002c-0.16092-0.15271-0.2605-0.35898-0.28-0.57999
c0-0.35001,0.45999-0.56,0.85001-0.66c2.51437-0.61105,5.15536-0.44009,7.57001,0.48999c2.44,0.81003,5,1.38,7.41,2.33002
c0.88998,0.35001,4.29999,2.66998,5.06,1.25c0.28-0.53-0.26001-1.10001-0.75-1.47
C281.21924,486.00034,279.0116,484.71869,276.67999,483.69998L276.67999,483.69998z"
            />
            <path
              id="路径_00000038376714395513884130000012009135990213626265_"
              class="st5"
              d="M180.14999,306.48999
c-17.78963-1.12405-35.63957-0.86996-53.38999,0.76001c6.82-7,16.07999-11.28,25.6-13.53c18.71001-4.43002,39-1.74002,57.94-0.19
c15.45999,1.25998,31.42999,4.22998,44.34999,13.62c-0.14-0.10001-11.09,3.07999-12.43999,3.23999
c-4.31436,0.5321-8.67453,0.58243-13,0.14999C212.66,308.97998,196.41,307.37,180.14999,306.48999z"
            />
            <path
              id="路径_00000127751735367128161250000012134519638941724056_"
              class="st5"
              d="M398.23001,306.48999
c17.78961-1.12405,35.63956-0.86996,53.38998,0.76001c-6.82001-7-16.07999-11.28-25.60001-13.53
c-18.70999-4.43002-39-1.74002-57.94-0.19c-15.45999,1.25998-31.42999,4.22998-44.34998,13.62
c0.13998-0.10001,11.09,3.07999,12.42999,3.23999c4.31439,0.53128,8.67447,0.5816,13,0.14999
C365.72,308.97998,382,307.37,398.23001,306.48999z"
            />
            <path
              id="路径_00000129163770573191228320000007215447891969449607_"
              class="st4"
              d="M298,547.06h-9.42999
c-15.24158-0.6178-30.36749-2.92523-45.10001-6.88c-7.3125-1.9519-14.50476-4.32928-21.54001-7.12
c-3.12999-1.23999-7.31999-2.40002-10-4.33002c-3.48-2.52002,0.59001-5.48999,3.77-3.39001
c0.93073,0.69086,1.79152,1.47125,2.57001,2.33002c3.31,3.23999,10.44,4.67999,15,6.19c5.83,1.94,11.78,3.62,17.8,5
c12.35748,2.86627,24.95538,4.57367,37.63,5.09998h9.28c13.40915-0.55469,26.73059-2.43384,39.76999-5.60999
c6.49805-1.58075,12.90994-3.49664,19.20999-5.73999c2.54001-0.90997,5.72-1.65002,7.76001-3.34998
c1.88-1.57001,2.82999-3.42999,5.51001-4.22003c2.26999-0.66998,6.88998,0.45001,4.94,3.23999
c-1.47,2.10004-7.47,3.57001-9.93002,4.55005c-7.02438,2.81482-14.20651,5.21887-21.50998,7.19995
c-14.90005,4.03394-30.20593,6.38202-45.63,7L298,547.06z"
            />
            <path
              id="路径_00000140007992002776309500000007904383067220642702_"
              class="st3"
              d="M317.81,574.52997
c-6.78787,1.50012-13.67615,2.50275-20.60999,3c-2.08002,0.11005-4.15002,0.17004-6.23001,0.19
c-2.07999,0.02002-4.14999-0.07996-6.23001-0.19c-6.93384-0.49725-13.82211-1.49988-20.60999-3
c-5.53-1.10999-8.32001,1.64001-7.64001,6.12c0.68002,4.48004,5.66,7.45001,10.21002,9.65002
c7.59958,3.49628,15.90921,5.17395,24.26999,4.90002c8.35764,0.2749,16.66425-1.40283,24.26001-4.90002
c4.56-2.20001,9.53-5.15997,10.20999-9.65002C326.12,576.15997,323.34,573.41998,317.81,574.52997z"
            />
            <path
              id="路径_00000147216406891425947220000005627889299921522622_"
              class="st6"
              d="M170.36,370.78998
c6.35001,2.20001,12.52,1,19.17999,2.10001c12.67001,2,27.67001-0.13998,40-3.81c2.89-0.87,5.92001,1,7.75-1.37
c4-5.09-5.42999-15.07001-9.14-18.87c-5.93999-6.08002-13.87-9.74002-22.22-11.41
C187.24001,333.69998,166.27,338,153.49001,352.28c-0.96919,0.93384-1.66135,2.11743-2,3.41998
c-0.12296,1.67606,0.39133,3.33676,1.43999,4.64999C156.88,366.37,163.37,368.35999,170.36,370.78998z"
            />
            <path
              id="路径_00000048477022769608974170000018267220959219198867_"
              class="st3"
              d="M237.75999,352.25998
c-0.93639,0.0307-1.81473-0.45261-2.28999-1.25998c-6.24001-12-22-20.5-39.17-21.05002
c-16.32472-0.3414-32.22104,5.23917-44.75,15.70999c-1.03436,0.82913-2.50565,0.82913-3.54001,0
c-0.46298-0.35995-0.73381-0.91354-0.73381-1.5c0-0.58643,0.27083-1.14005,0.73381-1.5
c13.57593-11.30048,30.78061-17.31003,48.44-16.91998c19.07001,0.60999,36.58,10.09,43.57001,23.57001
c0.25493,0.53503,0.25943,1.15558,0.0123,1.69424c-0.24715,0.5387-0.72046,0.94-1.2923,1.09573
C238.42448,352.2074,238.09329,352.26135,237.75999,352.25998z"
            />
            <path
              id="路径_00000061455388921404100550000004716374383359371407_"
              class="st7"
              d="M202.58,336.72998
c-3.58664-1.17224-7.41939-1.37579-11.11-0.59c-11,2.47-15.75,14.11002-13.49001,24.39999
c0.77,3.51001,2.75,9.64001,6.73001,10.81c2.51999,0.73001,6.31999,0,9,0.13c3.04999,0.14999,6.09999,0.41,9.12999,0.79001
c3.38,0.41,6.77,0.09,8.67-3.08002c5.70001-9.47998,6-25.62997-5.83-31.23999
C204.67685,337.47046,203.6409,337.06277,202.58,336.72998z"
            />
            <path
              id="路径_00000145767183090357688610000014171249923755666348_"
              class="st3"
              d="M198.05,375.13998
c-21,0-44.61-3.51001-48.67-15.84c-0.28046-0.84851-0.08693-1.78217,0.50766-2.44931c0.5946-0.66714,1.49995-0.96637,2.375-0.785
c0.87506,0.18137,1.58688,0.8158,1.86734,1.66431c4,12.10001,42.70999,14.5,67.61,10.84
c1.70998-0.23151,3.43451-0.33844,5.15999-0.31998c2.02931,0.08792,4.05867-0.17252,6-0.77002
c0.85037-0.2977,1.79515-0.11484,2.47301,0.4787c0.67784,0.59354,0.98389,1.50589,0.80109,2.38815
c-0.18282,0.88223-0.8262,1.59784-1.68408,1.87317c-2.42589,0.75317-4.96153,1.09125-7.5,1
c-1.50121-0.0177-3.00174,0.07251-4.49001,0.26999C214.39787,374.60379,206.22832,375.15512,198.05,375.13998L198.05,375.13998z"
            />
            <path
              id="路径_00000063611002726765001210000005235383528503749518_"
              class="st8"
              d="M240.16,365.44998
c-0.57875-2.51733-1.44441-4.95999-2.58-7.28l-0.42-0.88998c-0.14-0.29001-0.32001-0.57001-0.48001-0.85001l-1-1.70001
c-0.34999-0.54999-0.73999-1.07999-1.09999-1.63c-0.36-0.54999-0.74001-1.09-1.16-1.59998l-1.24001-1.54001
c-0.42-0.51001-0.89-1-1.34-1.47c-0.87-1-1.87999-1.87-2.84-2.79001c-2.00426-1.76938-4.15533-3.36514-6.42999-4.76999
c-2.2859-1.41971-4.68387-2.65045-7.17001-3.67999l-1.89-0.72c-0.31999-0.12003-0.62999-0.25-0.95-0.36002l-1-0.29001l-2-0.59998
l-2-0.47c-5.28632-1.18228-10.7169-1.58655-16.12-1.20001c-5.36469,0.40231-10.66037,1.45673-15.77,3.14001
c-1.25,0.44998-2.53,0.84998-3.75999,1.37c-0.61,0.25-1.24001,0.47998-1.85001,0.73999l-1.81999,0.82001l-0.90001,0.41998
l-0.89999,0.44l-1.77,0.89001c-6.58,3.29999-12,8.22-18.89999,11c2.69,1.42999,5.70999,2.91,8.67,2.16998
c1.83537-0.64352,3.515-1.66562,4.92999-3c6.79001-5.31,16.39-10.78,25-12.22998c2.44409-0.48322,4.91533-0.81717,7.40001-1
c9.925-0.82764,19.88168,1.16925,28.72,5.75998C228.5732,348.72128,235.85205,356.22903,240.16,365.44998L240.16,365.44998z"
            />
            <path
              id="路径_00000091735569521214903130000018403171760521450916_"
              class="st6"
              d="M416.26001,370.78998
c-6.35001,2.20001-12.52002,1-19.18002,2.10001c-12.66998,2-27.66998-0.13998-40-3.81c-2.88998-0.87-5.91998,1-7.75-1.37
c-4-5.09,5.43002-15.07001,9.14001-18.87c5.94-6.08002,13.87-9.74002,22.22-11.41c18.69-3.73001,39.66,0.57001,52.44,14.85001
c0.96918,0.93384,1.66135,2.11743,2,3.41998c0.12292,1.67606-0.39133,3.33676-1.44,4.64999
C429.73999,366.37,423.25,368.35999,416.26001,370.78998z"
            />
            <path
              id="路径_00000145767929447677122520000002025577163981044399_"
              class="st3"
              d="M348.85999,352.25998
c-0.34113-0.00269-0.67932-0.06357-1-0.17999c-0.57184-0.15573-1.04514-0.55707-1.29227-1.09573
c-0.24716-0.5387-0.24265-1.15924,0.01227-1.69427c7-13.47998,24.5-23,43.57001-23.56998
c17.65939-0.39005,34.86411,5.61951,48.44,16.91998c0.46298,0.35995,0.73383,0.91354,0.73383,1.5s-0.27084,1.14005-0.73383,1.5
c-1.03436,0.8291-2.50565,0.8291-3.54001,0c-12.53122-10.46683-28.42599-16.04688-44.75-15.70999
c-17.19,0.54999-32.92999,9-39.16998,21.04999C350.66336,351.78867,349.79346,352.27921,348.85999,352.25998z"
            />
            <path
              id="路径_00000181767033529827796610000008961929719314356412_"
              class="st7"
              d="M384,336.72998
c3.58664-1.17224,7.41937-1.37579,11.10999-0.59c11,2.47,15.75,14.11002,13.49002,24.39999
c-0.77002,3.51001-2.75,9.64001-6.73001,10.81c-2.51999,0.73001-6.32001,0-9,0.13c-3.04999,0.14999-6.10001,0.41-9.13,0.79001
c-3.38,0.41-6.76999,0.09-8.66998-3.08002c-5.70001-9.47998-6-25.62997,5.82999-31.23999
C381.90317,337.47046,382.93909,337.06277,384,336.72998z"
            />
            <path
              id="路径_00000145056945426719986310000002102447505889536403_"
              class="st3"
              d="M388.57001,375.13998
c-8.1676,0.02332-16.32706-0.51797-24.42001-1.62c-1.48825-0.19748-2.9888-0.28769-4.48999-0.26999
c-2.53848,0.09125-5.07413-0.24683-7.5-1c-0.85788-0.27533-1.50128-0.99094-1.68408-1.87317
c-0.1828-0.88226,0.12323-1.79462,0.80109-2.38815c0.67783-0.59351,1.62262-0.7764,2.47299-0.4787
c1.94135,0.5975,3.9707,0.85794,6,0.77002c1.72549-0.01846,3.45001,0.08847,5.16,0.31998
c24.89999,3.66,63.62,1.26001,67.60999-10.84c0.28046-0.84851,0.99228-1.48294,1.86734-1.66431s1.7804,0.11786,2.375,0.785
s0.78812,1.6008,0.50766,2.44931C433.17999,371.62,409.51999,375.13998,388.57001,375.13998z"
            />
            <path
              id="路径_00000142159544613225722510000014871976232809222586_"
              class="st8"
              d="M346.45999,365.44998
c0.57877-2.51733,1.44443-4.95999,2.58002-7.28l0.41998-0.88998c0.14001-0.29001,0.32001-0.57001,0.48001-0.85001l1-1.70001
c0.35001-0.54999,0.73999-1.07999,1.10001-1.63c0.35999-0.54999,0.73999-1.09,1.16-1.59998l1.23999-1.54001
c0.41998-0.51001,0.88998-1,1.34-1.47c0.87-1,1.88-1.87,2.84-2.79001c2.00424-1.76938,4.15533-3.36514,6.42999-4.76999
c2.28592-1.41971,4.68387-2.65045,7.17001-3.67999l1.88998-0.72c0.32001-0.12003,0.63-0.25,1-0.36002l1-0.29001L378.06,335.28
l2-0.47c5.28632-1.18228,10.71689-1.58655,16.12-1.20001c5.36469,0.40231,10.66037,1.45673,15.77002,3.14001
c1.25,0.44998,2.53,0.84998,3.75998,1.37c0.61002,0.25,1.24002,0.47998,1.85001,0.73999l1.82001,0.82001l0.89999,0.41998
l0.89999,0.44l1.77002,0.89001c6.57999,3.29999,12,8.22,18.89999,11c-2.69,1.42999-5.70999,2.91-8.67001,2.16998
c-1.83536-0.64352-3.51498-1.66562-4.92999-3c-6.79001-5.31-16.39001-10.78-25-12.22998
c-2.44409-0.48322-4.91531-0.81717-7.39999-1c-9.97778-0.82187-19.98358,1.21048-28.85001,5.85999
C357.98163,348.81903,350.75299,356.28699,346.45999,365.44998z"
            />
            <path
              id="路径_00000041992466830228341810000001413018550430707850_"
              class="st9"
              d="M502.54999,166.82999
c-9.76999-36.46001-29.48999-69.25-62.28-93.44c-19.03195-14.07505-40.70758-24.16631-63.72998-29.67
c-15.8457-3.76788-31.92456-6.4772-48.13-8.11c-8.16348-0.69853-16.35928-0.94557-24.55002-0.74
c-1.36972-0.35727-2.79413-0.45563-4.19998-0.29c-2.24667,0.12667-4.47668,0.21-6.69,0.25
c-2.21335,0.04-4.44666-0.04333-6.70001-0.25c-1.40582-0.16563-2.83026-0.06727-4.19998,0.29
c-8.19073-0.20557-16.38654,0.04147-24.55002,0.74c-16.20544,1.6328-32.2843,4.34212-48.12999,8.11
c-23.02242,5.50368-44.69804,15.59495-63.73,29.67c-32.78001,24.19-52.51,57-62.28001,93.44
c-11.75,43.85001-8.8,86.73,3.28001,129.87c4.28,15.26001,8.73,30.66,14.25,45.56c-1.51-41.26999-8.8-92.23999,4.85999-131.57999
c6.67001-19.22,21.24001-41.39,34.2-56.83c16.81-20,45.45-26.62,70.5-34.08c23-6.86,47.64999-8.81001,71.56-9
c3.53,0,7.20001-0.14,10.94-0.25c3.73999,0.11,7.39999,0.22,10.92999,0.25c23.91,0.2,48.53,2.15,71.56,9
c25.05002,7.46,54.30002,16.81999,71.10001,36.84c13,15.44,24.23001,28.59,30.89999,47.82001
c13.66,39.34,9.07001,96.56,7.56,137.82999c5.52002-14.89999,10-30.29999,14.25-45.56
C511.35001,253.55998,514.29999,210.67999,502.54999,166.82999z"
            />
            <path
              id="路径_00000156586220901220022980000010501949613607810451_"
              class="st9"
              d="M209.66,62.20999
c32.22-10.15,65.85999-7.15,97.56,3.36c12.82001,4.24001,24,13.91,36.41,19.5c10.48999,4.71,25,11.43,36.57999,10.54
c2.81-0.22,5.76001-0.89,7.78-2.87c3.79001-3.71001,2.66-10,0.75-15c-11.35999-29.48-39.28-49.25-67.72998-63
c-12.77002-6.16-26.10001-11.52-40.12-13.67c-23.14001-3.54-47.00002,2-68.06001,12.25s-39.48,25.17-56.64,41.09
c-28.19,26.24-55.82,55.59-74.59,89.37c-5.17,9.32001-10.33,18.81-12.93,29.15001c-2.6,10.34-2.4,21.78999,2.76,31.11
c1.31,2.36,2.94,4.62,3.48,7.25999c0.67,3.31-0.48,6.69-1.21001,10c-1.32989,5.94992-1.32989,12.12007,0,18.06999
c0.58,2.59001,1.65,5.40001,4.06001,6.49001c5.23,2.37,9.36-4.89999,10.50999-10.52c5.89001-28.57999,11.31001-57.59,23.41-84.14
C130.53999,109.83999,166.33,75.84999,209.66,62.20999z"
            />
            <path
              id="路径_00000182493159066567071420000013079531989277203389_"
              class="st9"
              d="M405.60999,108.28999
c-12.72919-8.13216-26.0575-15.28606-39.87-21.4l0,0c-10.63-4.56-33.19-0.46-33.00119-18.37
c0.06119-5.38,3.11121-10.38,7.1412-13.94c7.20999-6.38,17.32999-8.66,26.94998-8.22c9.62003,0.44,18.93002,3.33,28.12003,6.2
c34,10.61,59,25,85.34998,49.5c7.61002,7.07,15.15002,14.38,20.81,23.09c28.67999,44.09,11.44,119.71999-2.94998,166.07999
c1.38998-4.45999-2.31-22.60001-3-28.13c-1-7.71999-3.70999-15.65999-5.34-23.29999
c-4.33936-20.60062-10.94974-40.65651-19.71002-59.8c-7.28-15.78999-16.16998-31-28.15997-43.64
C431.35999,125.23999,418.62,116.42999,405.60999,108.28999z"
            />
            <path
              id="路径_00000130643462398107155300000004676789277891464364_"
              class="st9"
              d="M416.94,118.64999
c-21.32001-9-42.79999-13.13-64.58002-15.2c-19.93997-1.89-40.12-2-60.64999-2.49001
c-20.53998,0.47-40.71999,0.60001-60.65999,2.49001c-21.78,2.07-43.26001,6.22-64.58,15.2c-23.28,9.8-44.82,25.29-58,46.81001
c16.57-11.52,37-21.79001,57.14999-24.55c9.24001-1.27,18.56-3.19,27.88-4.12c4.17-0.42001,30.13-3.49001,32.31-0.22
c-2.68439-4.00058-6.55099-7.06311-11.06-8.76c18.56238-3.38504,37.72351-0.48183,54.45001,8.24999l-4.75-10.99999
c10.82303,5.70538,20.15909,13.86674,27.25998,23.82999c7.10608-9.96985,16.45352-18.13217,27.29001-23.82999l-4.75,10.99999
c16.74435-8.73277,35.92484-11.62569,54.5-8.21999c-4.509,1.69689-8.37561,4.75942-11.06,8.76
c2.17999-3.27,28.13998-0.2,32.31,0.22c9.32001,0.92999,18.64001,2.84999,27.88,4.12c20.10999,2.75999,40.57999,13,57.14999,24.55
C461.76001,143.93999,440.22,128.44998,416.94,118.64999z"
            />
          </g>
          <g
            id="face-front-mask"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
            fill-opacity="0"
          >
            <g fill-rule="nonzero" fill="#9687FA">
              <path
                id="耳朵-l"
                title="耳朵-l"
                d="M502.45999,284.47998c6.93002-0.75,13.23001,3.54001,16.68002,12.26001
c7.37,18.59,3,47.48001-0.42999,66.48999c-3.07001,17-7.25003,36.89999-14.55002,53.86002
c-2.40103,5.69922-5.34457,11.15433-8.79001,16.28998c-4,5.90002-12.75,19.38-21.88,24.22l0,0
c8.21637-48.71356,12.76248-97.97546,13.60001-147.37c0.10001-5.26999,0.16-10.53,0.14001-15.82001l0,0
c1.16046-1.51401,2.44849-2.92584,3.84998-4.22c3.75-3.40997,7.65002-5.28,11.38-5.67999"
              />
              <path
                id="耳朵-r"
                title="耳朵-r"
                d="M84.88,290.09c3.81001,0.31,7.82,2.16998,11.67001,5.69c0.34,0.31,0.77,0.72,1.1,1.04999l0,0
c0,4.47,0.06,8.89999,0.14,13.35999c0.85641,50.85818,5.65411,101.57346,14.35,151.69v0.10001c-8.33-5.63-16-17.5-19.75-22.92999
c-3.44216-5.13947-6.38235-10.5979-8.78-16.29999c-7.31-17-11.49-36.90002-14.55-53.86002c-3.43-19-7.8-47.89999-0.43-66.48999
c3.4-8.59,9.52-12.92001,16.29-12.35001"
              />
              <path
                id="头皮"
                title="头皮"
                d="M502.42999,284.47c2.28003-9.46228,4.07568-19.03473,5.38-28.68001
c10.17999-43.69,15.45001-96.62001-6.72-130.70001c-5.66-8.71-13.19998-16-20.81-23.09c-16.22-15.11-31.95001-26.36-49.59-35.25
c-16.61923-10.69433-34.92737-18.50107-54.14999-23.09c-5-1.21-10.08002-2.28-15.16-3.26
c-11.98001-10.4-26.10001-18.79-40.38-25.66c-12.76999-6.16-26.10001-11.52-40.12-13.67c-23.14001-3.54-47,2-68.06,12.25
s-39.48001,25.17-56.64001,41.09C128,80.58999,100.37,109.93999,81.6,143.71999c-5.17,9.32001-10.33,18.81-12.93,29.14999
c-2.6,10.34001-2.4,21.79001,2.76,31.11c1.31,2.36,2.94,4.62001,3.48,7.26001c0.67,3.31-0.48,6.69-1.21001,10
c-1.32989,5.94992-1.32989,12.12007,0,18.06999c0.51,2.26001,1.39,4.69,3.21001,6
C78.36265,260.39645,81.02793,275.34143,84.88,290l0,0c3.81001,0.31,7.82,2.16998,11.67001,5.68997
c0.34,0.31003,0.77,0.72,1.1,1.05002l0,0c0.6,0.57999,0.73,0.10999,0.71-0.42001c-1.5-29.60999-1.49-60.18999,7.41-85.82999
c0.38-1.10001,0.79-2.21001,1.22-3.33l0,0c0,0,23.74-58,184.75-58.49001c114.06-0.34999,174.93002,36.68001,186.71002,58.49001
l0,0c8,25.13,9.04999,56.93001,8.39999,87.12999c0,0.56,0.39999,0,0.39999,0l0,0c1.16046-1.51401,2.44852-2.92584,3.85001-4.22
c3.75-3.41,7.64999-5.28,11.38-5.67999"
              />
              <path
                id="前额"
                title="前额"
                d="M98.44,332.54999c0,0,186.31-53.26001,388,0l0,0c0.29999-7.44,0.51666-14.88,0.64999-22.32001
c0.63-33.92999,1-71.84999-8.91-103l0,0c-11.78-21.81-72.41-58.84-186.47-58.48999C130.7,149.26999,107,207.27998,107,207.27998
c-11.46,30.2-9.81,68.55-9.17,103.00002c0.14,7.44,0.35667,14.87997,0.65,22.31998L98.44,332.54999z"
              />
              <path
                id="鼻部"
                title="鼻部"
                d="M353.10001,322.18997c-7.20001,5-14.79001,9.44-22.24002,14.52002
c-12.72998,8.67999-16.84998,21.84-16.73999,36.88c0.08002,11.66998,1.45999,23.28998,2.32001,34.92999
c0.84,11.45999,1.82999,24.07999,5,35.16998c3.38998,11.74002,10.07999,23,9.54999,35.51001
c-0.13,3.27002-0.89999,6.72-3.31,9.07001c-1.44452,1.35544-3.34912,2.11298-5.32999,2.12l0,0
c-4.31,2.20001-9.41,2.54999-14.07001,3.95001c-5.88998,1.75998-10.04999,5.78-16.56,6.17999
c-9.56,0.59-17.57001-6.09-26.66-8.79001c-1.70334-0.39746-3.36188-0.96707-4.95001-1.69998
c-0.42728-0.22202-0.82672-0.49393-1.18997-0.81l-0.06003-0.06003c-2.45999,2.06003-6.67999,1.37003-8.99998-0.88998
c-2.32001-2.26001-3.18001-5.79999-3.31-9.07001c-0.53-12.48999,6.16-23.76999,9.55-35.51001
c3.19998-11.09,4.19-23.70999,5-35.16998c0.85999-11.64001,2.23999-23.26001,2.32001-34.92999
c0.10999-15-4-28.20001-16.74002-36.88C235,328.72998,223,322.22998,212.62,313l0,0
c52.65341-5.22751,105.68365-5.4552,158.38-0.68002l0,0c-1.3931,1.41983-2.95862,2.65948-4.66,3.69
c-4.20755,2.4682-8.63687,4.5372-13.23001,6.17999"
              />
              <path
                id="眼部-r"
                title="眼部-r"
                d="M101.79,383.75998c0,0,78.55,40.92001,161.16,2.70001l0,0
c0.29999-4.28,0.5-8.57001,0.53-12.87c0.10999-15-4-28.20001-16.74001-36.88C235,328.72998,223,322.22998,212.62,313h-0.19
C143.02,319.76999,98.43,332.54999,98.43,332.54999l0,0c0.66666,17.06668,1.78333,34.13666,3.35,51.20999H101.79z"
              />
              <path
                id="眼部-l"
                title="眼部-l"
                d="M314.64999,386.45999c82.61002,38.22,168.45001-2.70001,168.45001-2.70001l0,0
c1.54666-17.05331,2.66-34.12332,3.34-51.20999l0,0c-37.85815-9.90662-76.46912-16.67291-115.44-20.23001l-0.09,0.09
c-1.36343,1.39017-2.89926,2.60001-4.57001,3.60001c-4.20755,2.4682-8.63687,4.5372-13.23001,6.17999l0,0
c-7.19998,5-14.78998,9.44-22.23999,14.52002c-12.72998,8.67999-16.85001,21.84-16.73999,36.88
C314.14999,377.88998,314.35001,382.17999,314.64999,386.45999z"
              />
              <path
                id="面颊-r"
                title="面颊-r"
                d="M247,482.42999c-15.59,1.45999-74.14999,9.06-69.52,47.45001
c2.65001,21.88995,15.66,36,33.16,45.38l0,0c0,0-12.08,17.53998-40.44,23.65997l0,0c-20.66-22.52997-38.47-49.13-45.95-79.52997
c-10.86224-44.58081-18.3567-89.91528-22.42-135.62003l0,0c0,0,78.55,40.91998,161.15999,2.70001l0,0
c-0.5,7.35999-1.25,14.70999-1.78998,22.06c-0.84003,11.45999-1.83002,24.07999-5,35.16998
c-3.39001,11.73999-10.08002,23-9.55002,35.51001c0.03372,1.08505,0.15749,2.16544,0.37001,3.22998"
              />
              <path
                id="面颊-l"
                title="面颊-l"
                d="M314.64999,386.45999c0.5,7.35999,1.25,14.70999,1.79001,22.06
c0.84,11.45999,1.82999,24.07999,5,35.16998c3.38998,11.74002,10.07999,23,9.54999,35.51001
c-0.0271,0.81393-0.10391,1.62546-0.22998,2.42999l0,0c16.25998,1.46002,83,9.86002,78.13998,48.25003
c-2.28,18.15997-12.78,31.54999-27.26999,41.39996L381.5,571.37c0,0,9.29999,15.71002,38.63,21.41998l0,0
c18.29999-21.19,33.69-45.71997,40.5-73.41998c10.87369-44.57721,18.38483-89.90799,22.47-135.61002l0,0
C483.10001,383.75998,397.26001,424.67999,314.64999,386.45999"
              />
              <path
                id="口部"
                title="口部"
                d="M381.53,571.37c14.48999-9.85004,25.12-23.33002,27.39999-41.48999
c4.83002-38.39001-61.88-46.79001-78.13998-48.25003l0,0c-0.27322,2.49051-1.3551,4.82288-3.08002,6.64001
c-1.44452,1.35544-3.34912,2.11298-5.32999,2.12l0,0c-4.31,2.20001-9.41,2.54999-14.07001,3.95001
c-5.88998,1.75998-10.04999,5.78-16.56,6.17999c-9.56,0.59-17.57001-6.09-26.66-8.79001
c-1.70334-0.39746-3.36188-0.96707-4.94998-1.69998c-0.42731-0.22202-0.82675-0.49393-1.19-0.81l-0.06-0.06003
c-2.46002,2.06003-6.68001,1.37003-9.00002-0.88998c-1.54182-1.56653-2.56172-3.57138-2.92-5.73999v-0.10001
c-15.59,1.45999-74.14999,9.06-69.52,47.45001c2.65001,21.88995,15.66,36,33.16,45.38C234,587.83997,265.54001,592,291,595.14001
l0,0C316,595.14001,355.14999,589.28998,381.53,571.37z"
              />
              <path
                id="下巴"
                title="下巴"
                d="M170.16,598.90997c28.36-6.12,40.42999-23.64996,40.42999-23.64996l0,0
C234,587.83997,265.54001,592,291,595.14001l0,0c25,0,64.09-5.79004,90.47-23.71002l0.09-0.06
c0,0,9.29999,15.71002,38.63,21.41998l0,0c-2.04666,2.35999-4.12332,4.69336-6.23001,7C397.62,617.41998,382,636,363.25,651
c-20.14001,16.16998-41.17999,20.46997-66.45001,20.83997H292.44h-4.36002C262.81,671.46997,241.77,667.16998,221.63,651
c-18.73001-15-34.37001-33.57001-50.68001-51.23004c-0.27-0.27997-0.53-0.56-0.78999-0.84998V598.90997z"
              />
              <path
                id="颈部"
                title="颈部"
                d="M286.45999,829c1.62424-0.1377,3.23355-0.41541,4.81-0.83002
c3.95471-1.16156,7.73773-2.8429,11.25-5c7-4.21002,13.27002-9.41998,19.93002-13.57001
c3.20416-2.09863,6.62363-3.84857,10.19998-5.21997c3.59155-1.29584,7.30826-2.21411,11.09-2.73999
c7.63-1.11005,15.55002-1.23004,23.63-1.43005c32.20001-0.81,64.37-2.12,96.53-3.71997s115.70999,3,129.51999-9.83002
C555.25,775.13,518.51001,763.76001,479.5,748.95001c-21.64001-8.21002-44.09-34.73004-52.54001-56.17004
c-3.67999-9.34998-4.31-19.57001-4.88998-29.58997c-0.32001-5.56-0.61002-11.16003-0.89999-16.79004
c-1.07001-20-0.34003-37.75-0.53-54.08997c-2.20001,2.54663-4.43335,5.04999-6.70001,7.51001C397.62,617.41998,382,636,363.25,651
c-20.14001,16.16998-41.17999,20.46997-66.45001,20.83997H292.44h-4.36002C262.81,671.46997,241.77,667.16998,221.63,651
c-18.73001-15-34.37001-33.57001-50.68001-51.23004c-0.53999-0.56995-1.06999-1.15997-1.59999-1.73999l0,0
c0.06999,14.63-0.08,33.57001,0,48.76001l0,0c-0.26001,5.27002-0.13,11.13-0.43001,16.34003c-0.58,10-1.2,20.23999-4.89,29.58997
c-8.44,21.44-30.89999,48-52.53,56.17004C73.18,763.41998,37.39,775.73999,0,787.13c13.81,12.83997,76.85,7.67999,109,9.29999
s64.33,2.90997,96.53,3.71997c8.08,0.20001,16,0.32001,23.64,1.43005c3.77847,0.526,7.49185,1.44427,11.08,2.73999
c3.57867,1.37329,7.00124,3.12311,10.21001,5.21997c6.64998,4.15002,12.89,9.35999,19.93001,13.57001
c3.51038,2.16064,7.29388,3.84222,11.25,5c1.57626,0.41547,3.18564,0.69318,4.81,0.83002"
              />
            </g>
          </g>
        </g>
      </svg>
    </SvgPanZoom>
    <SvgPanZoom
      v-if="backMode"
      :panEnabled="false"
      :zoomEnabled="false"
      :controlIconsEnabled="false"
      :dblClickZoomEnabled="false"
      :preventMouseEventsDefault="false"
      :fit="true"
      :contain="true"
      :center="true"
      @svgpanzoom="registerSvgPanZoom"
      :customEventsHandler="customEventsHandler"
    >
      <svg
        :style="{
          width: svgWidth,
          height: svgHeight,
        }"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          id="Page-1"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
        >
          <g class="face" fill-rule="nonzero">
            <path
              d="M521.93,302.499987 C516.62,289.089987 504.58,286.159987 493.93,295.929987 C492.920424,296.865358 491.974954,297.867623 491.1,298.929987 C491.26,262.469987 488.6,225.609987 476.32,191.699987 C466.46,164.479987 449.65,139.139987 426.74,122.759987 C405.22,107.369987 373.54,104.179987 348.2,101.209987 C333.032722,99.2631525 317.733011,98.5441497 302.45,99.0599872 C300.15,98.9499872 297.86,98.8999872 295.56,98.864978 C293.26,98.8399872 290.97,98.9499872 288.68,99.0599872 C273.420837,98.5415938 258.144714,99.2538999 243,101.189987 C217.66,104.189987 186,107.349987 164.46,122.739987 C141.55,139.119987 124.74,164.459987 114.88,191.679987 C103.48,223.059987 100.36,257.059987 100.08,290.869987 C99.86,290.659987 99.66,290.429987 99.44,290.219987 C88.73,280.449987 76.69,283.389987 71.38,296.799987 C64.01,315.389987 68.38,344.279987 71.81,363.289987 C74.88,380.289987 79.06,400.189987 86.36,417.149987 C88.7610251,422.849209 91.7045743,428.304319 95.15,433.439987 C98.6,438.489987 105.5,449.109987 113.15,455.099987 C116.716667,476.746654 121.05,498.19332 126.15,519.439987 C136.31,561.439987 165.37,593.889987 169.15,638.089987 C169.5,642.089987 169.78,646.429987 172.15,649.709987 C173.8,652.019987 176.3,653.519987 178.75,654.909987 C207.27,670.909987 244.19,681.059987 276.97,676.499987 C280.81,675.969987 284.71,675.499987 288.64,674.949987 L295.52,675.859987 L302.41,674.949987 C306.34,675.469987 310.23,675.949987 314.07,676.499987 C346.85,681.059987 383.77,670.959987 412.29,654.909987 C414.74,653.519987 417.24,652.019987 418.89,649.709987 C421.25,646.429987 421.52,642.129987 421.89,638.089987 C425.69,593.889987 454.75,561.439987 464.89,519.439987 C469.383333,500.879987 473.263333,482.13332 476.53,463.199987 C485.53,458.199987 494.13,444.969987 498.12,439.149987 C501.562162,434.010517 504.502348,428.552084 506.9,422.849987 C514.21,405.849987 518.39,385.949987 521.45,368.989987 C524.94,349.979987 529.3,321.059987 521.93,302.499987 Z"
              id="路径"
              fill="#FCEBD8"
            ></path>
            <path
              d="M88,166.829987 C97.77,130.369987 117.5,97.5799872 150.28,73.3899872 C169.308968,59.3161438 190.981089,49.224935 214,43.7199872 C229.845691,39.9521039 245.924543,37.2427857 262.13,35.6099872 C270.293464,34.9114559 278.489284,34.6644129 286.68,34.8699872 C288.049741,34.5127126 289.474154,34.4143603 290.88,34.5799872 C293.133333,34.7066538 295.366667,34.7899872 297.58,34.8299872 C299.793333,34.8699872 302.023333,34.7866538 304.27,34.5799872 C305.675846,34.4143603 307.100259,34.5127126 308.47,34.8699872 C316.660716,34.6644129 324.856536,34.9114559 333.02,35.6099872 C349.225457,37.2427857 365.304309,39.9521039 381.15,43.7199872 C404.172416,49.2236721 425.848052,59.3149339 444.88,73.3899872 C477.67,97.5799872 497.39,130.389987 507.16,166.829987 C518.91,210.679987 515.96,253.559987 503.88,296.699987 C499.6,311.959987 495.15,327.359987 489.63,342.259987 C491.15,300.989987 498.43,250.019987 484.77,210.679987 C478.1,191.459987 463.53,169.289987 450.57,153.849987 C433.76,133.849987 405.12,127.229987 380.07,119.769987 C357.07,112.909987 332.42,110.959987 308.51,110.769987 C304.98,110.769987 301.32,110.629987 297.58,110.519987 C293.84,110.629987 290.17,110.739987 286.64,110.769987 C262.73,110.969987 238.11,112.919987 215.09,119.769987 C190.09,127.229987 160.78,136.589987 143.98,156.609987 C130.98,172.049987 119.76,185.199987 113.08,204.429987 C99.4,243.769987 104,300.989987 105.5,342.259987 C99.98,327.359987 95.5,311.959987 91.25,296.699987 C79.17,253.559987 76.22,210.679987 88,166.829987 Z"
              id="路径"
              fill="#4E4D4D"
            ></path>
            <path
              d="M380.86,62.2099872 C348.64,52.0599872 315,55.0599872 283.3,65.5699872 C270.48,69.8099872 259.3,79.4799872 246.89,85.0699872 C236.4,89.7799872 221.89,96.4999872 210.32,95.6099872 C207.5,95.3899872 204.55,94.7199872 202.53,92.7399872 C198.74,89.0299872 199.87,82.7399872 201.78,77.7399872 C213.14,48.2599872 241.06,28.4899872 269.51,14.7399872 C282.28,8.57998716 295.61,3.21998716 309.63,1.06998716 C332.77,-2.47001284 356.63,3.06998716 377.69,13.3199872 C398.75,23.5699872 417.17,38.4899872 434.33,54.4099872 C462.55,80.5899872 490.15,109.939987 508.92,143.719987 C514.1,153.039987 519.25,162.529987 521.85,172.869987 C524.45,183.209987 524.25,194.659987 519.09,203.979987 C517.78,206.339987 516.15,208.599987 515.61,211.239987 C514.94,214.549987 516.09,217.929987 516.82,221.239987 C518.14989,227.189914 518.14989,233.36006 516.82,239.309987 C516.24,241.899987 515.17,244.709987 512.76,245.799987 C507.53,248.169987 503.4,240.899987 502.25,235.279987 C496.36,206.699987 490.94,177.689987 478.84,151.139987 C460,109.839987 424.19,75.8499872 380.86,62.2099872 Z"
              id="路径"
              fill="#4E4D4D"
            ></path>
            <path
              d="M184.91,108.289987 C197.639206,100.157818 210.967517,93.0039211 224.78,86.8899872 L224.78,86.8899872 C235.41,82.3299872 257.97,86.4299872 257.781193,68.5199872 C257.72,63.1399872 254.67,58.1399872 250.64,54.5799872 C243.43,48.1999872 233.31,45.9199872 223.7,46.3599872 C214.09,46.7999872 204.76,49.6899872 195.57,52.5599872 C161.57,63.1699872 136.57,77.5599872 110.22,102.059987 C102.62,109.129987 95.07,116.439987 89.41,125.149987 C60.75,169.239987 78,244.869987 92.38,291.229987 C90.99,286.769987 94.69,268.629987 95.38,263.099987 C96.38,255.379987 99.09,247.439987 100.72,239.799987 C105.059333,219.199368 111.66973,199.143472 120.43,179.999987 C127.71,164.209987 136.6,148.999987 148.59,136.359987 C159.16,125.239987 171.9,116.429987 184.91,108.289987 Z"
              id="路径"
              fill="#4E4D4D"
            ></path>
            <path
              d="M496.1,161.819987 C481.1,131.929987 451.74,110.959987 421.19,95.2599872 C383.11,75.6999872 339.19,62.4199872 296.79,66.3599872 C254.36,62.4199872 210.47,75.6999872 172.39,95.2599872 C141.84,110.959987 112.44,131.929987 97.48,161.819987 C86.59,183.599987 84.25,208.369987 84.54,232.499987 C85.35,299.329987 98.27,367.299987 118.7,431.899987 C138.03,492.979987 151.22,552.789987 185.39,608.139987 C192.22,619.209987 200.48,630.569987 212.79,634.839987 C227.55,639.949987 243.46,633.499987 258.49,629.239987 C270.970972,625.716401 283.829412,623.702024 296.79,623.239987 C309.750588,623.702024 322.609028,625.716401 335.09,629.239987 C350.09,633.499987 366.03,639.949987 380.79,634.839987 C393.1,630.569987 401.36,619.209987 408.19,608.139987 C442.36,552.789987 455.55,492.979987 474.88,431.899987 C495.31,367.299987 508.23,299.329987 509.04,232.499987 C509.33,208.369987 507,183.599987 496.1,161.819987 Z"
              id="路径"
              fill="#4E4D4D"
            ></path>
            <path
              d="M593.42,788.729987 C555.25,777.209987 518,769.649987 479.5,751.059987 C458.67,740.989987 435.41,716.329987 426.96,694.889987 C423.28,685.539987 422.65,675.319987 422.07,665.299987 C421.75,659.739987 421.44,645.919987 421.91,638.129987 C280.12,693.279987 169.21,638.129987 169.21,638.129987 C169.21,641.869987 169.31,645.509987 169.32,648.959987 L169.32,648.959987 C169.06,654.229987 169.19,660.099987 168.89,665.299987 C168.31,675.299987 167.69,685.539987 164,694.889987 C155.56,716.329987 132.55,741.529987 111.47,751.059987 C69.29,770.059987 37.39,777.869987 0,789.259987 C29.39,815.319987 541.06,814.869987 593.42,788.729987 Z"
              id="路径"
              fill="#FCEBD8"
            ></path>
          </g>
          <g
            id="face-back-mask"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
            fill-opacity="0"
          >
            <g fill-rule="nonzero" fill="#9687FA">
              <path
                d="M505.6,290.15401 C512.39,289.58401 518.54,293.87401 521.93,302.44401 C529.3,321.03401 524.93,349.92401 521.5,368.93401 C518.44,385.93401 514.26,405.83401 506.95,422.79401 C504.552348,428.496106 501.612162,433.954539 498.17,439.09401 C494.17,444.91401 485.6,458.17401 476.58,463.14401 C473.006221,466.601338 468.404631,468.802099 463.47,469.41401 L463.47,469.41401 C467.17,456.96401 470.89,444.41401 474.88,431.84401 C489.45,385.77401 500.2,337.99401 505.46,290.13401"
                id="耳朵-r"
                title="耳朵-r"
              ></path>
              <path
                d="M127.74,461.44401 C122.318662,460.920939 117.206511,458.67846 113.15,455.04401 C105.5,449.04401 98.6,438.43401 95.15,433.38401 C91.7045743,428.248341 88.7610251,422.793232 86.36,417.09401 C79.06,400.09401 74.88,380.19401 71.81,363.23401 C68.38,344.23401 64.01,315.33401 71.38,296.74401 C74.74,288.25401 80.8,283.96401 87.51,284.43401 C92.51,334.20401 103.51,383.93401 118.7,431.84401 C121.84,441.74401 124.81,451.62401 127.7,461.44401 L127.74,461.44401 Z"
                id="耳朵-l"
                title="耳朵-l"
              ></path>
              <path
                d="M505.46,290.13401 C509.372605,275.43442 512.08815,260.442068 513.58,245.30401 C515.4,243.99401 516.28,241.56401 516.79,239.30401 C518.11989,233.354083 518.11989,227.183937 516.79,221.23401 C516.06,217.93401 514.91,214.55401 515.58,211.23401 C516.12,208.59401 517.75,206.33401 519.06,203.97401 C524.22,194.65401 524.42,183.20401 521.82,172.86401 C519.22,162.52401 514.1,153.00401 508.92,143.72401 C490.15,109.94401 462.55,80.59401 434.33,54.41401 C417.17,38.49401 398.72,23.61401 377.69,13.32401 C356.66,3.03400996 332.77,-2.46599004 309.63,1.07400996 C295.63,3.22400996 282.28,8.58400996 269.51,14.74401 C255.25,21.61401 241.12,30.00401 229.14,40.40401 C224.06,41.40401 219,42.45401 213.98,43.66401 C194.757979,48.2547683 176.450134,56.0613821 159.83,66.75401 C142.19,75.64401 126.46,86.89401 110.24,102.00401 C102.64,109.07401 95.09,116.38401 89.43,125.09401 C67.26,159.17401 72.53,212.09401 82.71,255.79401 C83.99,265.36401 87.51,284.39401 87.51,284.39401 C92.51,334.17401 103.51,383.93401 118.7,431.84401 C121.84,441.74401 124.81,451.62401 127.7,461.44401 C122.278662,460.920939 117.166511,458.67846 113.11,455.04401 C116.676667,476.690677 121.01,498.137343 126.11,519.38401 C136.27,561.38401 165.33,593.83401 169.11,638.03401 C169.11,638.03401 280.02,693.18401 421.81,638.03401 C425.61,593.83401 454.67,561.38401 464.81,519.38401 C469.303333,500.82401 473.183333,482.077343 476.45,463.14401 C472.876221,466.601338 468.274631,468.802099 463.34,469.41401 C467.04,456.95401 470.76,444.41401 474.75,431.84401 C489.32,385.77401 500.07,337.99401 505.33,290.13401"
                id="头皮"
                title="头皮"
              ></path>
              <path
                d="M593.42,788.67401 C555.25,777.15401 518,769.59401 479.5,751.00401 C458.67,740.93401 435.41,716.27401 426.96,694.83401 C423.28,685.48401 422.65,675.26401 422.07,665.24401 C421.75,659.68401 421.44,645.86401 421.91,638.07401 C280.12,693.22401 169.21,638.07401 169.21,638.07401 C169.21,641.81401 169.31,645.45401 169.32,648.90401 L169.32,648.90401 C169.06,654.17401 169.19,660.04401 168.89,665.24401 C168.31,675.24401 167.69,685.48401 164,694.83401 C155.56,716.27401 132.55,741.47401 111.47,751.00401 C69.29,770.00401 37.39,777.81401 0,789.20401 C29.39,815.26401 541.06,814.81401 593.42,788.67401 Z"
                id="颈部"
                title="颈部"
              ></path>
            </g>
          </g>
        </g>
      </svg>
    </SvgPanZoom>
  </div>
</template>
<script>
import SvgPanZoom from 'vue-svg-pan-zoom';
import registerSVG from './mixin';

export default {
  mixins: [registerSVG],
  props: {
    svgWidth: Number,
    svgHeight: Number,
    backMode: Boolean,
    selectedParts: Array,
  },
  components: {
    SvgPanZoom,
  },
};
</script>
<style lang="less" scoped>
.face {
  .st0 {
    fill: #fcebd8;
  }
  .st1 {
    fill: #e8d0aa;
  }
  .st2 {
    fill: #eedabe;
  }
  .st3 {
    fill: #f1ddc0;
  }
  .st4 {
    fill: #c5a894;
  }
  .st5 {
    fill: #80736b;
  }
  .st6 {
    fill: #ffffff;
  }
  .st7 {
    fill: #725d4c;
  }
  .st8 {
    fill: #76655a;
  }
  .st9 {
    fill: #4e4d4d;
  }
}
</style>
